import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { apiUrl } from '../../config/api';
import './LoginModal.scss';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const ForgetPassModel = ({ show, onClose }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      setEmail('');
      setError('');
      setIsSubmitting(false);
    }
  }, [show]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!EMAIL_PATTERN.test(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }

    if (isSubmitting) return;
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch(apiUrl('/api/forgot-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      // The original reported success regardless of the response
      // status, so a rejected address looked like it had worked.
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        setError(data.message || 'We could not send the reset link. Please try again.');
        return;
      }

      onClose();
      Swal.fire({
        icon: 'success',
        confirmButtonColor: '#a17e33',
        title: 'Check your inbox',
        text: 'We have sent a password reset link to your email.',
      });
    } catch (err) {
      setError('Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <span className="auth-modal__brand-label">Password reset</span>
      </Modal.Header>
      <Modal.Body>
        <div className="auth-modal">
          <h2 className="auth-modal__title">Forgot your password?</h2>
          <p className="auth-modal__subtitle">
            Enter the email on your account and we&apos;ll send you a reset link.
          </p>

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            {error && (
              <p className="alert alert--error" role="alert">
                {error}
              </p>
            )}

            <div className="field">
              <label className="field__label" htmlFor="forgot-email">
                Email
              </label>
              <input
                id="forgot-email"
                className="input"
                type="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  setError('');
                }}
                aria-invalid={Boolean(error)}
                disabled={isSubmitting}
                autoComplete="email"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn--primary btn--block"
              disabled={isSubmitting}
              aria-busy={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="btn__spinner" aria-hidden="true" />
                  Sending…
                </>
              ) : (
                'Send reset link'
              )}
            </button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPassModel;
